import {ReactComponent as PlFlag} from "../images/flag-icons/pl.svg";
import {ReactComponent as EnFlag} from "../images/flag-icons/en.svg";
import { FC, SVGProps } from "react";

export interface LocalLanguage{
    symbol: string,
    image: FC<SVGProps<SVGSVGElement>>
}

export function getSupportedLanguages(): LocalLanguage[] {
    return [
        {
            symbol: "pl",
            image: PlFlag
        },
        {
            symbol: "en",
            image: EnFlag
        }
    ];
}

export function getDefaultLanguage(): LocalLanguage {
    return {
        symbol: "en",
        image: EnFlag
    }
}